const products = [
  {
    id: 'vpn',
    name: 'VETON VPN',
    tagline: 'Secure. Private. Fast.',
    description:
      'A powerful VPN solution built natively for iOS. VETON VPN encrypts your internet connection, masks your IP address, and keeps your online activity completely private — whether you\'re on public Wi-Fi or at home.',
    highlights: ['Military-grade AES-256 encryption', 'Zero-log policy', 'Lightning-fast servers', 'One-tap connection'],
    gradient: 'from-slate-700 to-slate-900',
    iconBg: 'bg-slate-600/40',
    icon: 'ri-shield-keyhole-line',
    image: 'https://public.readdy.ai/ai/img_res/a924d25658fd30a615b3e5506ead4eeb.jpg',
  },
  {
    id: 'cleaner',
    name: 'VETON Cleaner',
    tagline: 'Clean. Optimize. Perform.',
    description:
      'Keep your iPhone running at peak performance. VETON Cleaner intelligently identifies and removes junk files, duplicate photos, and unnecessary cache data — freeing up storage and boosting your device\'s speed.',
    highlights: ['Smart junk detection', 'Duplicate photo finder', 'Cache & temp file removal', 'Storage analytics'],
    gradient: 'from-emerald-800 to-slate-900',
    iconBg: 'bg-emerald-600/30',
    icon: 'ri-sparkling-line',
    image: 'https://readdy.ai/api/search-image?query=iPhone%20cleaner%20optimization%20app%20interface%20showing%20storage%20usage%20charts%20and%20clean%20up%20progress%2C%20modern%20iOS%20app%20with%20green%20accents%2C%20minimalist%20design%2C%20white%20clean%20background%2C%20professional%20product%20mockup%20photography&width=600&height=700&seq=cleaner-product-veton&orientation=portrait',
  },
];

export default function Products() {
  return (
    <section id="products" className="bg-[#f7f8fa] py-28 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="text-slate-500 text-xs font-semibold tracking-[0.25em] uppercase">Our Products</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-4">
            Built for iOS. Built for You.
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Premium applications crafted with precision for the Apple ecosystem.
          </p>
        </div>

        <div className="flex flex-col gap-10">
          {products.map((product, idx) => (
            <div
              key={product.id}
              className={`bg-white rounded-3xl overflow-hidden border border-gray-100 flex flex-col ${
                idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              }`}
            >
              {/* Image side */}
              <div className={`relative md:w-2/5 bg-gradient-to-br ${product.gradient} flex items-center justify-center p-10 min-h-[320px]`}>
                <div className="w-full max-w-[220px] mx-auto rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src={product.image}
                    alt={`${product.name} app screenshot`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className={`absolute top-6 left-6 w-12 h-12 flex items-center justify-center ${product.iconBg} rounded-xl backdrop-blur-sm`}>
                  <i className={`${product.icon} text-white text-2xl`} />
                </div>
              </div>

              {/* Content side */}
              <div className="md:w-3/5 p-10 md:p-14 flex flex-col justify-center">
                <span className="text-slate-400 text-xs font-semibold tracking-widest uppercase mb-3">{product.tagline}</span>
                <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5">{product.name}</h3>
                <p className="text-gray-500 text-base leading-relaxed mb-8">{product.description}</p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {product.highlights.map((item) => (
                    <li key={item} className="flex items-center gap-3 text-gray-700 text-sm">
                      <span className="w-5 h-5 flex items-center justify-center bg-slate-100 rounded-full flex-shrink-0">
                        <i className="ri-check-line text-slate-600 text-xs" />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
